import { ReactElement } from 'react';
import { JobImagesContainer } from '../../../../modules/jobs/containers/details/JobImages.container';

export const InferenceDetailsImagesView = (): ReactElement => <JobImagesContainer />;
